import { PaceAnswers } from "@/types/answers";

export const enum FactorType {
    FirstPredict = "firstPredict",
    FirstPredictLowLoss = "firstPredictLowLoss",
    SecondPredict = "secondPredict",
    SecondPredictLowLoss = "secondPredictLowLoss",
}

// kgs per week
//  Weight Predictor 2.0
const firstPredictWeightLossFactor = {
    [PaceAnswers.fast]: 0.8,
    [PaceAnswers.steady]: 0.69,
    [PaceAnswers.between_two]: 0.69,
};

const firstPredictLowWeightLossFactor = {
    [PaceAnswers.fast]: 0.7,
    [PaceAnswers.steady]: 0.59,
    [PaceAnswers.between_two]: 0.59,
};

const secondPredictWeightLossFactor = {
    [PaceAnswers.fast]: 1,
    [PaceAnswers.steady]: 0.8,
    [PaceAnswers.between_two]: 0.8,
};

const secondPredictLowWeightLossFactor = {
    [PaceAnswers.fast]: 0.85,
    [PaceAnswers.steady]: 0.7,
    [PaceAnswers.between_two]: 0.7,
};

export const factors = {
    [FactorType.FirstPredict]: firstPredictWeightLossFactor,
    [FactorType.FirstPredictLowLoss]: firstPredictLowWeightLossFactor,
    [FactorType.SecondPredict]: secondPredictWeightLossFactor,
    [FactorType.SecondPredictLowLoss]: secondPredictLowWeightLossFactor,
};
